import {
    SET_MODULE,
    SET_PANEL,
    SET_STATES,
    SET_TYPES,
    SET_ACTION_MAP,
    SET_USER_FEATURE_MAP,
    SET_LOADING_MAP,
    SET_FILTERS_MAP,
    UPDATE_FILTER_ITEM_MAP,
} from './mutation-types';

const mutations = {
    // [SET_MODULE](state, module) {
    //     let settings = module.settings;
    //     if(settings){
    //         let skeys = Object.keys(settings);
    //         let tools = state.data.tools;
    //         for (let pkey of Object.keys(tools)) {
    //             let tool = tools[pkey];
    //             let panel = tool.panel;
    //             let model = tool.model;
    //             if(model){
    //                 let skey = skeys.find( k => k==model);
    //                 if(skey){
    //                     let filteredSettings = Object.keys(settings[skey]).filter((k) => {
    //                         return Object.keys(panel).includes(k);
    //                     });
    //                     for (let fkey of filteredSettings) {
    //                         Object.assign(panel[fkey], settings[skey][fkey]);
    //                     }
    //                 }
    //             }
    //         }
    //     }
    //     delete module.settings;
    //     state.data.module = module;
    // },
};

export default mutations;
